<template>
  <svg viewBox="0 0 85 40">
    <g>
      <g :style="'fill:' + color">
        <polygon points=" 0 0 75 0 81 18 75 36 0 36 7 18" />
      </g>
      <g style="fill: white; font-weight: bold; stroke: white">
        <text
          xml:space="preserve"
          x="50%"
          y="50%"
          dominant-baseline="middle"
          text-anchor="middle"
          style="stroke: none"
          v-text="text"
        />
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class IconBlockArrow extends Vue {
  @Prop(String) text?: string;
  @Prop({ default: 'black' }) color!: string;
}
</script>
